<template>
  <div class="preview-mobile">
    <div
      class="mobile-head"
      :class="client"
      :style="{ backgroundColor: headBgColor }"
    >
      <div class="mobile-head-title">{{ headTitle }}</div>
    </div>
    <div class="mobile-body" :class="{ scroll: scroll }">
      <slot name="body"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "NormalPreviewItem",
  data() {
    return {};
  },
  props: {
    scroll: {
      type: Boolean,
      default: false,
    },
    headTitle: {
      type: String,
      default: "",
    },
    headBgColor: {
      type: String,
      default: "#ffffff",
    },
    client: {
      type: String,
      default: "h5",
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-mobile {
  width: 100%;
  height: 100%;

  box-sizing: border-box;
  border: 4px solid #ffffff;
  background-color: #f7f8fa;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.mobile-body {
  width: 100%;
  height: 0;
  flex-grow: 1;

  &.scroll {
    overflow: auto;
  }

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none;
    background-color: transparent;
    border-radius: 0;
  }

  &::-webkit-scrollbar {
    width: 0;
    height: 0;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 0;
    background-color: rgba(181, 181, 181, 0);
  }
}

.mobile-head {
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  //   background-color: #ffffff;

  &.fixed {
    position: absolute;
    top: 0;
    left: 0;
  }

  &.mini {
    height: 88px;
    background-size: 100% 100%;
    background-image: url(https://image.ydleague.com/benefit/web_icons/icon_preview_mobile_head_wxxcx.png);

    padding: 42px 90px 0;
  }

  &.h5 {
    height: 88px;
    background-size: 100% 100%;
    background-image: url(https://image.ydleague.com/benefit/web_icons/icon_preview_mobile_head_wxh5.png);

    padding: 47px 90px 0;
  }

  .mobile-head-title {
    width: 100%;
    height: 32px;
    text-align: center;
    line-height: 32px;
    font-weight: 600;
    font-size: 16px;
    color: #1e2226;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}
</style>
